<template>
  <div>
    <div v-if="isVisible()"
         aria-hidden="true"
         aria-labelledby="exampleModalLabel"
         class="custom-modal modal fade show modal-backdrop modal-block-number profile-modal notify-user-modal"
         style="display: block;"
    >
      <div class="modal-dialog block-modal">
        <div class="modal-content modal-block-num">
          <button class="buy-number-modal-close-btn block-number-cloe-btn user-noty-close-btn"
                  @click="closeNotification"></button>
          <div class="block-number-content-middle"></div>
          <div class="buy-number-title buy-number-title-gray">
            {{ getLocalization('COUNTRIES HAS BEEN BLOCKED FOR YOU DUE TO YOUR LOW DELIVERY RATE') }}
          </div>
          <div class="ban-table">
            <div v-for="data in modalData.values" :key="data.id" class="table-row">
              <div class="table-cell responsive-cell">
                <img :src="data.service_variation.service.img_path">
                <span class="text">{{ data.service_variation.service.title }}</span>
              </div>
              <div class="table-cell responsive-cell">
                <img :src="data.service_variation.country.img_path">
                {{ getLocalization(data.service_variation.country.title) }}
              </div>
              <div class="table-cell table-cell-provider">
                <template v-if="data.agent_id">
                  {{ getLocalization('Provider') }}<br>{{ data.agent_id }}
                </template>
                <template v-else>
                  <div class="empty-provider">&nbsp;</div>
                </template>
              </div>
              <div class="table-cell ban-date">
                {{ getLocalization('up to') }} {{ data.banned_to_date }}<br>
                {{ data.banned_to_time }}
              </div>
            </div>
          </div>
          <div class="buy-number-content block-number-content row g-3">
            <div class="block-number-content-first col-12">
              <p> {{ getLocalization('How to increase code deliverability') }}</p>
            </div>
            <div class="d-flex article-btn-wrapper col-12">
              <div class="block-number-content-second">
                <img src="/img/svg/common/block-arrow.svg" alt="" class="block-number-arrow">
              </div>
              <div class="buy-number-content-third">
                <a  @click.prevent="closeNotificationByArticleButton($event)"  :href="getLocalization('Article link')" class="button primary fw-bolder block-btn link-block-btn">
                  <img src="/img/svg/common/check-circle.svg" class="block-svg-article">
                  {{ getLocalization('Article') }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'userBanModal',
  props: ['modalData'],
  data() {
    return {}
  },
  methods: {
    isVisible() {
      return this.modalData !== null && this.modalData !== undefined
          && this.modalData.values !== undefined && this.modalData.values !== null;
    },
    async closeNotificationByArticleButton(event) {
      const href = event.currentTarget.href;

      await this.closeNotification(event);

      setTimeout(() => {
        window.location.href = href;
      }, 600);
    },
    async closeNotification(event) {
      const modal = event.currentTarget.closest('.notify-user-modal');
      if (modal) {
        modal.style.display = 'none';
      }

      this.$emit('close', this.modalData.notificationIds);
    }
  }
}
</script>